/**
 * Small helper that persists the `requirePasswordReset` signal across
 * the app. The flag is set when:
 *  - Login response returns `requirePasswordReset: true`
 *  - A PIX (or other banking) operation returns `PASSWORD_RESET_REQUIRED`
 *
 * The router checks this flag and forces the user to `/reset-password-forced`
 * until they complete the password change. The flag is cleared on successful
 * password change or on logout.
 */

const STORAGE_KEY = 'security:requirePasswordReset';

export function setPasswordResetFlag(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // localStorage unavailable — noop
  }
}

export function clearPasswordResetFlag(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
}

export function isPasswordResetRequired(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
